// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"table_wrapper__7xvE5","table":"table_table__DgzTc","tableStriped":"table_tableStriped__sJckb"};